<template>
  <div class="col-md-6" v-if="stamp">
    <div class="form-group">
      <div my-15px>
        <label class="mx-5">
          <h4>
            Stamp Empty
            <span class="small light">Recommended size 108 x 108 pixels</span>
          </h4>
        </label>

        <div class="form-group">
          <div class="image-preview">
            <img class="img img-fluid" v-if="picture" :src="picture" />
            <div v-else class="image-placeholder"></div>
          </div>
          <input
            type="file"
            accept="image/*"
            class="form-control"
            @change="uploadImage"
            ref="stamp_empty_picture"
            name="stamp_empty_picture"
            :disabled="disabled"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stampFormMixins from "../stamp.form.mixins";

export default {
  props: ["campaign"],

  mixins: [stampFormMixins],

  data() {
    return {
      file: null,
      message: {
        error: "Upload Stamp empty picture error.",
        success: "Upload Stamp empty picture success.",
      },
    };
  },

  computed: {
    picture() {
      return this.campaign.stamp.stamp_empty_picture;
    },
  },

  methods: {
    validateFileUpload(event) {
      const file = event.target.files[0];

      if (file.size > 1000000) {
        event.target.files[0].value = "";
        throw new Error("File shall not exceed 1 MB");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/upload.form.scss";
</style>
